import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Column } from 'components/Blocks';
import { usePendingActions } from 'providers/PendingActions';

import { SingleQuotationRequest } from './Request';
import { TriStateWrapper } from '../components';

import { listRemove } from 'utils/array';

export function QuotationRequests() {
  const { t } = useLang();
  const { decreaseCount } = usePendingActions();

  const {
    data: requests,
    loading,
    overwrite,
  } = loaders.invoice.activeQuotationRequests.use({
    defaultValue: [],
  });

  const removeRequest = useCallback(
    (id: string) => {
      overwrite((old) => listRemove(old, id));

      decreaseCount('PENDING_QUOTATION_REQUESTS');
    },
    [overwrite, decreaseCount],
  );

  return (
    <TriStateWrapper
      loading={loading}
      message={!requests.length && t('no-quotation-request-right-now')}
    >
      <Column className="mx-auto w-[min(80%,850px)] phone:w-full">
        {requests.map((request) => (
          <SingleQuotationRequest
            key={request.id}
            request={request}
            removeSelf={() => removeRequest(request.id)}
          />
        ))}
      </Column>
    </TriStateWrapper>
  );
}
